!function (t, i) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = i(require("three")) : "function" == typeof define && define.amd ? define(["three"], i) : ((t = t || self).THREE = t.THREE || {}, t.THREE.TextTexture = i(t.THREE));
}(this, function (t) {
  "use strict";

  function i(t, i, e, n, o) {
    return [t, i, e, n + "px", o].join(" ");
  }
  function e(t) {
    return void 0 === t;
  }
  return function (n) {
    function o(e) {
      void 0 === e && (e = {});
      var o = e.align;
      void 0 === o && (o = "center");
      var r = e.anisotropy,
        s = e.createCanvas;
      void 0 === s && (s = function s() {
        return document.createElement("canvas");
      });
      var h = e.fillStyle;
      void 0 === h && (h = "#fff");
      var l = e.fontFamily;
      void 0 === l && (l = "sans-serif");
      var a = e.fontSize;
      void 0 === a && (a = 16);
      var f = e.fontStyle;
      void 0 === f && (f = "normal");
      var d = e.fontVariant;
      void 0 === d && (d = "normal");
      var u = e.fontWeight;
      void 0 === u && (u = "normal");
      var g = e.format,
        c = e.lineGap;
      void 0 === c && (c = .15);
      var x = e.loadFontFace;
      void 0 === x && (x = function x(t, e, n, o) {
        var r = i(e, n, o, 1, t);
        return document.fonts.load(r);
      });
      var p = e.magFilter;
      void 0 === p && (p = t.LinearFilter);
      var _ = e.mapping,
        v = e.minFilter;
      void 0 === v && (v = t.LinearFilter);
      var y = e.padding;
      void 0 === y && (y = .25);
      var P = e.strokeStyle;
      void 0 === P && (P = "#000");
      var S = e.strokeWidth;
      void 0 === S && (S = 0);
      var W = e.text;
      void 0 === W && (W = "");
      var I,
        m,
        k = e.type,
        w = e.wrapS,
        b = e.wrapT;
      n.call(this, s(), _, w, b, p, v, g, k, r), this._align = o, this._fillStyle = h, this._fontFamily = l, this._fontSize = a, this._fontStyle = f, this._fontVariant = d, this._fontWeight = u, this._lineGap = c, this._padding = y, this._strokeStyle = P, this._strokeWidth = S, this._text = W, this.createCanvas = s, this.loadFontFace = x, this.redraw = (I = this.redrawNow, function () {
        for (var t = this, i = [], e = arguments.length; e--;) i[e] = arguments[e];
        return m || (m = new Promise(function (t) {
          setTimeout(t, 0);
        }).then(function () {
          return I.apply(t, i);
        }).finally(function () {
          m = void 0;
        })), m;
      }), this.redrawNow();
    }
    n && (o.__proto__ = n), o.prototype = Object.create(n && n.prototype), o.prototype.constructor = o;
    var r = {
      text: {
        configurable: !0
      },
      lines: {
        configurable: !0
      },
      fontFamily: {
        configurable: !0
      },
      fontSize: {
        configurable: !0
      },
      fontWeight: {
        configurable: !0
      },
      fontVariant: {
        configurable: !0
      },
      fontStyle: {
        configurable: !0
      },
      font: {
        configurable: !0
      },
      fillStyle: {
        configurable: !0
      },
      strokeWidth: {
        configurable: !0
      },
      strokeWidthInPixels: {
        configurable: !0
      },
      strokeStyle: {
        configurable: !0
      },
      align: {
        configurable: !0
      },
      lineGap: {
        configurable: !0
      },
      lineGapInPixels: {
        configurable: !0
      },
      padding: {
        configurable: !0
      },
      paddingInPixels: {
        configurable: !0
      },
      textWidthInPixels: {
        configurable: !0
      },
      textHeight: {
        configurable: !0
      },
      textHeightInPixels: {
        configurable: !0
      },
      widthInPixels: {
        configurable: !0
      },
      height: {
        configurable: !0
      },
      heightInPixels: {
        configurable: !0
      }
    };
    return r.text.get = function () {
      return this._text;
    }, r.text.set = function (t) {
      this._text !== t && (this._text = t, this._lines = void 0, this._textWidthInPixels = void 0, this.redraw());
    }, r.lines.get = function () {
      return e(this._lines) && (this._lines = this.computeLines()), this._lines;
    }, o.prototype.computeLines = function () {
      var t = this.text;
      return t ? t.split("\n") : [];
    }, r.fontFamily.get = function () {
      return this._fontFamily;
    }, r.fontFamily.set = function (t) {
      this._fontFamily !== t && (this._fontFamily = t, this._textWidthInPixels = void 0, this.redraw());
    }, r.fontSize.get = function () {
      return this._fontSize;
    }, r.fontSize.set = function (t) {
      this._fontSize !== t && (this._fontSize = t, this._textWidthInPixels = void 0, this.redraw());
    }, r.fontWeight.get = function () {
      return this._fontWeight;
    }, r.fontWeight.set = function (t) {
      this._fontWeight !== t && (this._fontWeight = t, this._textWidthInPixels = void 0, this.redraw());
    }, r.fontVariant.get = function () {
      return this._fontVariant;
    }, r.fontVariant.set = function (t) {
      this._fontVariant !== t && (this._fontVariant = t, this._textWidthInPixels = void 0, this.redraw());
    }, r.fontStyle.get = function () {
      return this._fontStyle;
    }, r.fontStyle.set = function (t) {
      this._fontStyle !== t && (this._fontStyle = t, this._textWidthInPixels = void 0, this.redraw());
    }, r.font.get = function () {
      return i(this.fontStyle, this.fontVariant, this.fontWeight, this.fontSize, this.fontFamily);
    }, r.fillStyle.get = function () {
      return this._fillStyle;
    }, r.fillStyle.set = function (t) {
      this._fillStyle !== t && (this._fillStyle = t, this.redraw());
    }, r.strokeWidth.get = function () {
      return this._strokeWidth;
    }, r.strokeWidth.set = function (t) {
      this._strokeWidth !== t && (this._strokeWidth = t, this.redraw());
    }, r.strokeWidthInPixels.get = function () {
      return this._strokeWidth * this.fontSize;
    }, r.strokeStyle.get = function () {
      return this._strokeStyle;
    }, r.strokeStyle.set = function (t) {
      this._strokeStyle !== t && (this._strokeStyle = t, this.redraw());
    }, r.align.get = function () {
      return this._align;
    }, r.align.set = function (t) {
      this._align !== t && (this._align = t, this.redraw());
    }, r.lineGap.get = function () {
      return this._lineGap;
    }, r.lineGap.set = function (t) {
      this._lineGap !== t && (this._lineGap = t, this.redraw());
    }, r.lineGapInPixels.get = function () {
      return this.fontSize * this.lineGap;
    }, r.padding.get = function () {
      return this._padding;
    }, r.padding.set = function (t) {
      this._padding !== t && (this._padding = t, this.redraw());
    }, r.paddingInPixels.get = function () {
      return this.padding * this.fontSize;
    }, r.textWidthInPixels.get = function () {
      return e(this._textWidthInPixels) && (this._textWidthInPixels = this.computeTextWidthInPixels()), this._textWidthInPixels;
    }, o.prototype.computeTextWidthInPixels = function () {
      var t = this.createCanvas,
        i = this.font,
        e = this.lines;
      if (e.length) {
        var n = t().getContext("2d");
        return n.font = i, e.map(function (t) {
          return n.measureText(t).width;
        }).reduce(function (t, i) {
          return Math.max(t, i);
        });
      }
      return 0;
    }, r.textHeight.get = function () {
      var t = this.lineGap,
        i = this.lines;
      return i.length ? i.length + t * (i.length - 1) : 0;
    }, r.textHeightInPixels.get = function () {
      return this.textHeight * this.fontSize;
    }, r.widthInPixels.get = function () {
      return this.textWidthInPixels + this.strokeWidthInPixels + 2 * this.paddingInPixels;
    }, r.height.get = function () {
      return this.textHeight + this.strokeWidth + 2 * this.padding;
    }, r.heightInPixels.get = function () {
      return this.height * this.fontSize;
    }, o.prototype.redrawNow = function () {
      var t = this;
      return Promise.resolve().then(function () {
        return t.loadFontFace(t.fontFamily, t.fontStyle, t.fontVariant, t.fontWeight);
      }).then(function () {
        var i = t.image,
          e = i.getContext("2d");
        if (e.clearRect(0, 0, i.width, i.height), t.widthInPixels && t.heightInPixels) {
          var n;
          switch (i.width = t.widthInPixels, i.height = t.heightInPixels, e.font = t.font, e.textBaseline = "middle", t.align) {
            case "left":
              e.textAlign = "left", n = t.paddingInPixels + t.strokeWidthInPixels / 2;
              break;
            case "right":
              e.textAlign = "right", n = t.paddingInPixels + t.strokeWidthInPixels / 2 + t.textWidthInPixels;
              break;
            case "center":
              e.textAlign = "center", n = t.paddingInPixels + t.strokeWidthInPixels / 2 + t.textWidthInPixels / 2;
          }
          var o = t.paddingInPixels + t.strokeWidthInPixels / 2 + t.fontSize / 2;
          e.fillStyle = t.fillStyle, e.miterLimit = 1, e.lineWidth = t.strokeWidthInPixels, e.strokeStyle = t.strokeStyle, t.lines.forEach(function (i) {
            t.strokeWidthInPixels && e.strokeText(i, n, o), e.fillText(i, n, o), o += t.fontSize + t.lineGapInPixels;
          });
        } else i.width = i.height = 1;
        t.needsUpdate = !0;
      });
    }, Object.defineProperties(o.prototype, r), o;
  }(t.Texture);
});